// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"hX-z","sponsoredTooltipWrapper":"iX-z","sponsoredTooltip":"jX-z","newCard":"kX-z"};